export const EXTERNAL_ORDER_STATUSES = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  PREPARING: 'preparing',
  READY: 'ready',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const;

export type ExternalOrderStatus =
  (typeof EXTERNAL_ORDER_STATUSES)[keyof typeof EXTERNAL_ORDER_STATUSES];

/** Minimal tabs row shape from Supabase Realtime postgres_changes payloads. */
export type ExternalTabRealtimeRow = {
  id?: string;
  source_type?: 'pos' | 'external';
  external_order_status?: ExternalOrderStatus;
};

export const VALID_STATUS_TRANSITIONS: Record<
  ExternalOrderStatus,
  ExternalOrderStatus[]
> = {
  pending: ['accepted', 'cancelled'],
  accepted: ['preparing', 'completed', 'cancelled'],
  preparing: ['ready', 'completed', 'cancelled'],
  ready: ['completed', 'cancelled'],
  completed: [],
  cancelled: [],
};

export function isValidStatusTransition(
  current: ExternalOrderStatus,
  next: ExternalOrderStatus,
): boolean {
  return VALID_STATUS_TRANSITIONS[current]?.includes(next) ?? false;
}
